import React, { Component } from 'react';
import { Grid, withStyles } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

import { WEB_API } from '../common/Constants';
import ScrollPages from '../common/ScrollPages';
import Topbar from '../common/Topbar';
import Footer from '../common/Footer';
import Container from '../component/div/Container';

import './Business.css';

const styles = (theme) => ({
  imgWrap: {
    width: '20%',
    [theme.breakpoints.down('sm')]: {
      width: '33.3%',
    },
  },
  '&.fp-tableCell': {
    verticalAlign: 'baseline !important',
    display: 'none',
  },
  title01: { borderLeft: '3px solid #565656', paddingLeft: 15, fontSize: 26 },
  title02: {
    margin: '20px 0',
    paddingBottom: '0.5em',
    fontWeight: 'bold',
    color: theme.typography.color,
    borderBottom: '1px solid #eee',
  },
  allPagesMobile: {
    '& section.page_mob:nth-child(n+2)': {
      padding: theme.spacing(5, 5, 0),
    },
    '& section.page_mob:last-child': {
      padding: theme.spacing(5),
    },
  },
  scopeIcon: {
    '& img': {
      // width: '50%',
      height: '6em',
    },
    '& p': {
      margin: theme.spacing(1, 0, 2),
    },
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-evenly',
      '& p': {
        margin: 0,
      },
    },
  },
  scopeContent: {
    paddingLeft: 0,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '1em',
    },
  },
  clientWrapper: {
    width: '100%',
    height: '100%',
    padding: '5% 0',
    '& > div:nth-child(2)': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
  },
  clientLogoDiv: {
    width: '20%',
    height: '70px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(1.5, 2.5),
  },
  clientLogoDivMobile: {
    height: '50px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(0.5, 1),
  },
  clientLogo: {
    maxWidth: '80%',
    maxHeight: '80%',
    ['@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)']: {
      width: 'auto',
      height: 'auto',
      flex: '0 0 auto',
    },
  },
});

const features = [
  {
    img: 'feature_01@2x.png',
    title: 'Total Marketing',
    hash: '#Bring out the Concept & Branding #BTL Marketing',
    desc: `컨셉 도출 브랜딩^
    온·오프라인 PR^
    BTL Marketing`,
  },
  {
    img: 'feature_02@2x.png',
    title: 'Live Streaming Network',
    hash: '#Hybrid & Untact Online Symposium #Web Total Solution',
    desc: 'Hybrid & 비대면^ Online Symposium^ 기획 및 실행^ Web Total Solution 제공',
  },
  {
    img: 'feature_03@2x.png',
    title: 'Internal Event',
    hash: '#Town Hall Meetings #Workshops #Incentive Trips',
    desc: '다년간의 노하우를 바탕으로^ Town Hall Meeting,^ Workshop, Incentive Trip의^ 성공적 수행',
  },
  {
    img: 'feature_04@2x.png',
    title: 'Design',
    hash: '#Creative Design #Exclusive Material',
    desc: '프로젝트 컨셉에 맞는^ 디자인 및 On/Off-line^ Material 개발',
  },
];

let scrollInstance;

class Business extends Component {
  constructor(props) {
    super(props);
    this.state = {
      path: this.props.location.pathname.split('/')[2],
      location: 3,
    };

    this.refScope = React.createRef();
    this.refClient = React.createRef();
    this.refClient2 = React.createRef();
    this.refClient3 = React.createRef();

    this.clickHandler = this.clickHandler.bind(this);
  }

  componentDidMount() {
    this.setState({ path: this.props.location.pathname.split('/')[2] });
    this.getClientList();
    if (
      window.screen.width < 600 ||
      navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPod/i)
    ) {
      this.setState({ matches: true }, () => {
        let footer = document.getElementById('footer');
        footer.style.position = 'static';
      });
    } else {
      this.setState({ matches: false }, () => {
        scrollInstance = null;
        scrollInstance = new ScrollPages(1, 4, document.getElementById('all-pages'), 'business');
        scrollInstance.init();
        this.setInitialTop();
        this.setSectionHeight();
      });
    }
  }

  componentDidUpdate(props, state) {
    if (this.state.matches) {
      //모바일
      if (this.props.location.pathname.split('/')[2] === 'client') {
        document.getElementById('moveToClient').click();
      } else {
        document.getElementById('moveToScope').click();
      }
    } else {
      //웹
      this.setInitialTop();
    }
  }

  componentWillUnmount() {
    if (scrollInstance) {
      scrollInstance.remove();
    }
    scrollInstance = null;
  }

  setSectionHeight() {
    this.refScope.current.style.height = 'calc(100vh - 135px)';
    this.refClient.current.style.height = 'calc(100vh - 135px)';
    this.refClient2.current.style.height = 'calc(100vh - 135px)';
    this.refClient3.current.style.height = 'calc(100vh - 135px)';
  }

  clickHandler(e, elementId) {
    e.preventDefault();
    let href = document.getElementById(elementId).getAttribute('href');

    if (href === '#page_mob1') {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      sessionStorage.setItem('currentPage', 1);
    } else {
      let heightToScroll = document.getElementById('page_mob1').clientHeight;
      setTimeout(() => {
        window.scrollTo({
          top: heightToScroll - 90, //topbar + padding-top height
          behavior: 'smooth',
        });
      }, 1);
      sessionStorage.setItem('currentPage', 2);
    }
  }

  // 웹버전
  setInitialTop() {
    let pages = document.getElementById('all-pages');
    let viewHeight = document.documentElement.clientHeight;
    const cateTitle = document.getElementsByClassName('cate-title');
    const cateLine = document.getElementsByClassName('cate-line');

    //Clients의 category와 line width style 반응형
    for (let i = 0; i < cateTitle.length; i++) {
      cateLine[i].style.width = `calc(100% - ${cateTitle[i].offsetWidth + 1}px)`;
    }

    if (this.props.history.location.pathname.split('/')[2] === 'client') {
      pages.style.top = -viewHeight * 1 + 135 + 'px';
      sessionStorage.setItem('currentPage', 2);
    } else {
      pages.style.top = -viewHeight * 0 + 'px';
      sessionStorage.setItem('currentPage', 1);
    }
  }

  // 모바일
  setInitialTopMob() {
    if (this.state.path === 'client') {
      document.getElementById('moveToClient').click();
    } else {
      document.getElementById('moveToScope').click();
    }
  }

  setScrollButtonTop(num) {
    let pages = document.getElementById('all-pages');
    let viewHeight = document.documentElement.clientHeight;

    pages.style.top = -viewHeight * num + 135 * num + 'px';
    sessionStorage.setItem('currentPage', num + 1);
  }

  getClientList() {
    let pharmaceutical = [];
    let medicalSociety = [];
    let nonMedical = [];

    axios
      .get(`${WEB_API}/home/client/list`, {
        headers: {
          Pragma: 'no-cache',
        },
      })
      .then((res) => {
        pharmaceutical = res.data.Items.filter((item) => item.category === 'Pharmaceutical');
        medicalSociety = res.data.Items.filter((item) => item.category === 'MedicalSociety');
        nonMedical = res.data.Items.filter((item) => item.category === 'NoneMedical');

        this.sortingByTitleASC(pharmaceutical);
        this.sortingByTitleASC(medicalSociety);
        this.sortingByTitleASC(nonMedical);

        this.sortingBySortOrder(pharmaceutical);
        this.sortingBySortOrder(medicalSociety);
        this.sortingBySortOrder(nonMedical);

        this.setState({ pharmaceutical, medicalSociety, nonMedical });
      });
  }

  sortingBySortOrder = (obj) => {
    obj.sort((a, b) => {
      return a.sortOrder - b.sortOrder;
    });
  };

  sortingByTitleASC = (obj) => {
    obj.sort((a, b) => {
      let aTitle = a.title.toUpperCase();
      let bTitle = b.title.toUpperCase();
      if (aTitle < bTitle) {
        return -1;
      } else if (aTitle > bTitle) {
        return 1;
      } else {
        return 0;
      }
    });
  };

  render() {
    const { classes, theme } = this.props;

    const mapToComponent = (datas) => {
      return datas.map((data, idx) => (
        <Grid item xs={12} sm={12} md={3} key={`feature-item-${idx}`} className={'feature-item-container'}>
          <Grid container style={{ backgroundColor: '#fff', padding: '2em', height: '100%' }}>
            <Grid item xs={5} md={12} className={classes.scopeIcon}>
              <img src={`images/icon/${data.img}`} alt="icon" className={!this.state.matches && 'feature-icon-web'} />
              <p
                style={{ color: this.props.theme.typography.color, fontWeight: 'bold' }}
                className={!this.state.matches && 'feature-title-web'}
              >
                {data.title}
              </p>
            </Grid>
            <Grid item xs={7} md={12} className={classes.scopeContent}>
              <p
                style={{ color: this.props.theme.palette.primary.main, paddingBottom: '1.5em' }}
                className={!this.state.matches && 'feature-tags-web'}
              >
                {data.hash.split('#').map((tag, tidx) => {
                  if (tidx > 0) {
                    if (tidx - 1 !== data.hash.split('#').length) {
                      return (
                        <React.Fragment key={`feature-item-tag-${tidx}`}>
                          #{tag}
                          <br />
                        </React.Fragment>
                      );
                    } else {
                      return <React.Fragment key={`feature-item-tag-${tidx}`}>#{tag}</React.Fragment>;
                    }
                  }
                })}
              </p>
              <div style={{ color: this.props.theme.typography.color }} className={!this.state.matches && 'feature-content-web'}>
                {data.desc.split('^').map((line, idx) => {
                  return <p key={`line-${idx}`}>{line}</p>;
                })}
              </div>
            </Grid>
          </Grid>
        </Grid>
      ));
    };

    const renderClientTitle = () => {
      return (
        <div style={{ fontSize: 26, display: 'flex', alignItems: 'center' }} className={'class'}>
          <p style={{ display: 'inline-block', width: '6px', height: '1.25em', marginRight: '1em', backgroundColor: '#565656' }} />
          <span>Clients</span>
        </div>
      );
    };

    const renderClientCategory = (category) => {
      return (
        <>
          <div style={{ display: 'flex', flexDirection: 'row', margin: this.props.theme.spacing(1.5, 0) }}>
            <div style={{ paddingRight: '1em' }} className={'cate-title'}>
              {category}
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }} className={'cate-line'}>
              <div style={{ width: '100%', height: '1px', backgroundColor: '#eee' }} />
            </div>
          </div>
        </>
      );
    };

    const renderClientList = (category) => {
      return category.map((item, idx) => (
        <div key={`${category}-${idx + 1}`} className={`${classes.clientLogoDiv} client-logo-div-web`}>
          <img src={item.logo.path} alt={item.title} className={classes.clientLogo} />
        </div>
      ));
    };

    const renderClientListMobile = (category) => {
      return category.map((item, idx) => (
        <React.Fragment key={`mobile-${category}-${idx + 1}`}>
          <Grid item xs={4} className={classes.clientLogoDivMobile}>
            <img src={item.logo.path} alt={item.title} className={classes.clientLogo} />
          </Grid>
        </React.Fragment>
      ));
    };

    return this.state.matches ? (
      // 모바일
      <div>
        <div id="topbar_mob" className="topbar_mob" style={{ position: 'fixed', zIndex: 100, top: 0 }}>
          <Topbar currentPath={this.props.location.pathname} />
          <div className="page-header" style={{ backgroundColor: 'white', display: 'none' }}>
            <a id="moveToScope" href="#page_mob1" onClick={(e) => this.clickHandler(e, 'moveToScope')}>
              page_mob1
            </a>
            <a id="moveToClient" href="#page_mob2" onClick={(e) => this.clickHandler(e, 'moveToClient')}>
              page_mob2
            </a>
          </div>
        </div>

        <div className={classes.allPagesMobile} id="all-pages-mob">
          <section
            id="page_mob1"
            className="page_mob"
            style={{
              backgroundImage: `url('images/background/scope_bg.png')`,
              backgroundSize: '200% 100%',
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
            }}
          >
            <div
              style={{
                width: '80vw',
                maxWidth: '1020px',
                textAlign: 'center',
                color: '#fff',
                padding: '120px 0 80px',
              }}
            >
              <p style={{ fontWeight: 'bold', fontSize: '2em' }}>
                Total <span style={{ color: this.props.theme.palette.primary.main }}>MICE</span> Service
              </p>
              {/* <br /> */}
              <p>
                40여명의 전문 인력을 바탕으로 한<br />
                <span style={{ color: this.props.theme.palette.primary.main }}>참신한 기획과 디자인</span>
                <br /> 온/오프라인 <span style={{ color: this.props.theme.palette.primary.main }}>프로젝트의 안정적인 실행</span>
              </p>
              <p style={{ width: 60, height: 2, backgroundColor: '#fff', margin: '30px auto 50px' }} />
              <Grid container spacing={3}>
                {/* <Grid item container > */}
                {mapToComponent(features)}
                {/* </Grid> */}
              </Grid>
            </div>
          </section>

          <section id="page_mob2" className="page_mob" style={{ position: 'relative' }}>
            {renderClientTitle()}
            <div>
              <p className={classes.title02}>Pharmaceutical</p>{' '}
              <Grid container style={{ width: '80vw', margin: '0 auto' }}>
                {this.state.pharmaceutical && renderClientListMobile(this.state.pharmaceutical)}
              </Grid>
            </div>
          </section>

          <section className="page_mob" style={{ position: 'relative' }}>
            <div>
              <p className={classes.title02}>Medical Society</p>
              <Grid container style={{ width: '80vw', margin: '0 auto' }}>
                {this.state.medicalSociety && renderClientListMobile(this.state.medicalSociety)}
              </Grid>
            </div>
          </section>

          <section className="page_mob" style={{ position: 'relative' }}>
            <div>
              <p className={classes.title02}>Non Medical</p>
              <Grid container style={{ width: '80vw', margin: '0 auto' }}>
                {this.state.nonMedical && renderClientListMobile(this.state.nonMedical)}
              </Grid>
            </div>
          </section>
        </div>
        <Footer />
      </div>
    ) : (
      // 웹(
      <Container currentPath={this.props.location.pathname}>
        <div className="fullscreen-container">
          <div id="all-pages">
            <section
              className="page"
              ref={this.refScope}
              style={{ backgroundImage: `url('images/background/scope_bg.png')`, position: 'relative' }}
            >
              <div
                className="center"
                style={{ width: '80vw', maxWidth: '1020px', textAlign: 'center', color: '#fff', paddingBottom: '2vh' }}
              >
                <p style={{ fontWeight: 'bold', fontSize: '2em', marginBottom: theme.spacing(2) }} id={'scope-title-web'}>
                  Total <span style={{ color: this.props.theme.palette.primary.main }}>MICE</span> Service
                </p>
                <p>
                  40여명의 전문 인력을 바탕으로 한&nbsp;
                  <span style={{ color: this.props.theme.palette.primary.main }}>참신한 기획과 디자인</span>
                  <br /> 온/오프라인 <span style={{ color: this.props.theme.palette.primary.main }}>프로젝트의 안정적인 실행</span>
                </p>
                <p style={{ width: 60, height: 2, backgroundColor: '#fff', margin: '4% auto' }} id={'scope-division-line-web'} />
                <Grid container justify="center">
                  <Grid item container spacing={3}>
                    {mapToComponent(features)}
                  </Grid>
                </Grid>
              </div>
              <div className={'scrollButton scrollDown'} onClick={() => this.setScrollButtonTop(1)}>
                <img src="images/icon/scroll_down_white.png" alt="scroll_down" />
              </div>
            </section>
            <section className="page" ref={this.refClient} style={{ position: 'relative' }}>
              <div className={classes.clientWrapper}>
                <div className={'scrollButton scrollUp'} onClick={() => this.setScrollButtonTop(0)}>
                  <img src="images/icon/scroll_up_black.png" alt="scroll_up" />
                </div>
                <div className="center" style={{ width: '80%', height: '100%', padding: '5% 0' }}>
                  {renderClientTitle()}
                  <div style={{ padding: this.props.theme.spacing(2, 3) }}>
                    {renderClientCategory('Pharmaceutical')}
                    <Grid container style={{ maxWidth: '1020px', margin: '0 auto' }}>
                      {this.state.pharmaceutical && renderClientList(this.state.pharmaceutical)}
                    </Grid>
                  </div>
                </div>
                <div className={'scrollButton scrollDown'} onClick={() => this.setScrollButtonTop(2)}>
                  <img src="images/icon/scroll_down.png" alt="scroll_down" />
                </div>
              </div>
            </section>
            <section className="page" ref={this.refClient2} style={{ position: 'relative' }}>
              <div className={classes.clientWrapper}>
                <div className={'scrollButton scrollUp'} onClick={() => this.setScrollButtonTop(1)}>
                  <img src="images/icon/scroll_up_black.png" alt="scroll_up" />
                </div>
                <div className="center" style={{ width: '80%', height: '100%', padding: '5% 0' }}>
                  {renderClientTitle()}
                  <div style={{ padding: this.props.theme.spacing(2, 3) }}>
                    {renderClientCategory('Medical Society')}
                    <Grid container style={{ maxWidth: '1020px', margin: '0 auto' }}>
                      {this.state.medicalSociety && renderClientList(this.state.medicalSociety)}
                    </Grid>
                  </div>
                </div>
                <div className={'scrollButton scrollDown'} onClick={() => this.setScrollButtonTop(3)}>
                  <img src="images/icon/scroll_down.png" alt="scroll_down" />
                </div>
              </div>
            </section>
            <section className="page" ref={this.refClient3} style={{ position: 'relative' }}>
              <div style={{ height: '100%' }}>
                <div className={classes.clientWrapper}>
                  <div className={'scrollButton scrollUp'} onClick={() => this.setScrollButtonTop(2)}>
                    <img src="images/icon/scroll_up_black.png" alt="scroll_up" />
                  </div>
                  <div className="center" style={{ width: '80%', height: '100%', padding: '5% 0' }}>
                    {renderClientTitle()}
                    <div style={{ padding: this.props.theme.spacing(2, 3) }}>
                      {renderClientCategory('Non Medical')}
                      <Grid container style={{ maxWidth: '1020px', margin: '0 auto' }}>
                        {this.state.nonMedical && renderClientList(this.state.nonMedical)}
                      </Grid>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </Container>
    );
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(Business));
